import React, { useEffect, useState } from "react";
import { Inner } from "./styles";
import moment from "moment";
import CodeChangesList from "./code-changes-list/CodeChangesList";
import { CONSTANTS } from "../../../../utils/constants";
import { get_code_changes_history } from "../../../../api/endpoints/orders";

export default function CodeChanges({ clientId }) {
	const [step, setStep] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [codeChangeList, setCodeChangeList] = useState(null);
	const [searchInfo, setSearchInfo] = useState(null);
	const [paginationInputValue, setPaginationInputValue] = useState(null);
	const [pharmacies, setPharmacies] = useState(null);
	const [distributors, setDistributors] = useState(null);
	const [pointsOfSale, setPointsOfSale] = useState(null);
	const [laboratories, setLaboratories] = useState(null);
	const [selectedPharmacy, setSelectedPharmacy] = useState(null);
	const [selectedDistributor, setSelectedDistributor] = useState(null);
	const [selectedPointOfSale, setSelectedPointOfSale] = useState(null);
	const [selectedLaboratory, setSelectedLaboratory] = useState(null);
	const [rangeDate, setRangeDate] = useState(null);
	const [dateFrom, setDateFrom] = useState(null);
	const [dateTo, setDateTo] = useState(null);
	const [page, setPage] = useState(CONSTANTS.PAGE_LARGE_SIZE);
	const [actualPage, setActualPage] = useState(1);
	const [key, setKey] = useState(null);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const fetch_code_changes = async (skipValue) => {
		setIsLoading(true);
		try {
			const res = await get_code_changes_history(
				selectedPharmacy,
				selectedDistributor,
				selectedPointOfSale,
				selectedLaboratory,
				dateFrom,
				dateTo,
				skipValue,
				page
			);
			const resPharmacyOfCodes = JSON.parse(
				res?.paginationInfo?.pharmacyOfCodes
			);
			const resDistributorOfCodes = JSON.parse(
				res?.paginationInfo?.distributorOfCodes
			);
			const resPointOfSaleOfCodes = JSON.parse(
				res?.paginationInfo?.pointOfSaleOfCodes
			);
			const resLaboratoryOfCodes = JSON.parse(
				res?.paginationInfo?.laboratoryOfCodes
			);

			setCodeChangeList(res?.codeChanges);
			setSearchInfo(res?.paginationInfo);
			setPaginationInputValue(res?.paginationInfo?.actualPage?.toString());

			setPharmacies(
				resPharmacyOfCodes?.map((r) => ({
					value: r.PharmacyId,
					label: r.PharmacyName,
				}))
			);
			setDistributors(
				resDistributorOfCodes?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);
			setPointsOfSale(
				resPointOfSaleOfCodes?.map((r) => ({
					value: r.PointOfSaleId,
					label: r.PointOfSaleName,
				}))
			);
			setLaboratories(
				resLaboratoryOfCodes?.map((r) => ({
					value: r.LaboratoryId,
					label: r.LaboratoryName,
				}))
			);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setActualPage(1);
		setPage(CONSTANTS.PAGE_LARGE_SIZE);
		fetch_code_changes(1);
	}, [
		selectedPharmacy,
		selectedDistributor,
		selectedPointOfSale,
		selectedLaboratory,
		rangeDate,
	]);

	const handleSelectPharmacy = (e, o) => {
		setSelectedPharmacy(e);
	};

	const handleSelectDistributor = (e, o) => {
		setSelectedDistributor(e);
	};

	const handleSelectPointOfSale = (e, o) => {
		setSelectedPointOfSale(e);
	};

	const handleSelectLaboratory = (e, o) => {
		setSelectedLaboratory(e);
	};

	const handleSelectedDate = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleDeleteFilters = () => {
		setSelectedPharmacy(null);
		setSelectedDistributor(null);
		setSelectedPointOfSale(null);
		setSelectedLaboratory(null);
		setDateFrom(null);
		setDateTo(null);
		setRangeDate(null);
	};

	const handleDecrement = () => {
		if (searchInfo.actualPage > 1) {
			const cp = searchInfo.actualPage - 1;
			fetch_code_changes(cp);
			setActualPage(cp);
		}
	};

	const handleIncrement = () => {
		if (searchInfo.actualPage < searchInfo.totalPages) {
			const cp = searchInfo.actualPage + 1;
			fetch_code_changes(cp);
			setActualPage(cp);
		}
	};

	const handlePageChange = (e) => {
		const selectedPage = parseInt(e.target.value);
		if (
			!isNaN(selectedPage) &&
			selectedPage >= 1 &&
			selectedPage <= searchInfo.totalPages
		) {
			fetch_code_changes(selectedPage);
			setPaginationInputValue(selectedPage);
		} else {
			setPaginationInputValue(searchInfo.actualPage);
		}
	};

	return (
		<Inner>
			<CodeChangesList
				setKey={setKey}
				rangeDate={rangeDate}
				handleSelectedDate={handleSelectedDate}
				selectedPharmacy={selectedPharmacy}
				handleSelectPharmacy={handleSelectPharmacy}
				pharmacies={pharmacies}
				selectedDistributor={selectedDistributor}
				handleSelectDistributor={handleSelectDistributor}
				distributors={distributors}
				selectedPointOfSale={selectedPointOfSale}
				handleSelectPointOfSale={handleSelectPointOfSale}
				pointsOfSales={pointsOfSale}
				selectedLaboratory={selectedLaboratory}
				handleSelectLaboratory={handleSelectLaboratory}
				laboratories={laboratories}
				handleDeleteFilters={handleDeleteFilters}
				codeChangeList={codeChangeList}
				isLoading={isLoading}
				searchInfo={searchInfo}
				handleDecrement={handleDecrement}
				handlePageChange={handlePageChange}
				handleIncrement={handleIncrement}
				paginationInputValue={paginationInputValue}
				setPaginationInputValue={setPaginationInputValue}
				dateFrom={dateFrom}
				dateTo={dateTo}
			/>
		</Inner>
	);
}
